<template>
	<div>
		<div class="hero">
			<div class="title ml-5 mt-5" style="z-index: +3; color: white"><b style="font-size: 40px;">End User License Agreement</b></div>
			<v-img src="@/assets/moonlight.jpg" height="150" />
		</div>
		<v-container>		
			<div v-for="Document in documents" :key="Document.id" >
				<div v-if="Document.name === 'ECLA' ">
					<span v-html="Document.description"></span>
				</div>
			</div>
		</v-container>
	</div>
</template>

<script>
	import {db} from '@/firebase';
	export default {
		name : "terms",
		props: {
			msg: String
		},
		data: () => ({
			documents: [],
			nav_title: 'EULA',
		}),
		firestore() {
			return {
				documents: db.collection('documents')
			}
		}
	}
</script>

<style scoped>
  .title {
    position: absolute;
    top: 100px;
  }
</style>